// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd7e81c6","453":"1e2f3d1c","455":"1baf8175"}[chunkId] + ".chunk.js";
};